var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "80.75 423.00 15.00 19.50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f39800",
    d: "M86.35,437.92h-4.75v-1.97h4.75v-1.75h-4.75v-1.97h3.86l-4.62-9.18h4.1l1.78,4.37c.51,1.35,1.03,2.7,1.59,4.05h.13c.54-1.38,1.08-2.73,1.62-4.05l1.78-4.37h3.97l-4.64,9.18h3.91v1.97h-4.8v1.75h4.8v1.97h-4.8v4.59h-3.94v-4.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYenIcon);
export default __webpack_public_path__ + "static/media/yen_icon.7364dae10e52c1ce1c357b2b94467d93.svg";
export { ForwardRef as ReactComponent };